var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAkaDao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "akaDao",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.023,
    height: 24.023,
    viewBox: "0 0 24.023 24.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    fill: "none",
    stroke: "#efefef",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.012,
    cy: 12.012,
    r: 12.012,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.012,
    cy: 12.012,
    r: 11.512,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M36.186,50.7c.831-.933,1.545-1.741,2.267-2.543,2.32-2.578,4.648-5.148,6.956-7.737a1.168,1.168,0,0,1,1.023-.461c.638.035,1.28.009,1.956.009V50.9H46.332V42.03c-.285.3-.465.476-.629.665-2.163,2.479-4.335,4.95-6.476,7.448a1.347,1.347,0,0,1-1.243.566c-.541-.047-1.089-.01-1.8-.01",
    transform: "translate(-31.486 -33.585)",
    fill: "#efefef"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkaDao);
export default __webpack_public_path__ + "static/media/akaDao.d2173a0b.svg";
export { ForwardRef as ReactComponent };